import { createClient } from '@supabase/supabase-js';

// Self-hosted Supabase configuration for db.travelease.tech
export const CUSTOM_SUPABASE_URL = 'https://db.travelease.tech';
export const CUSTOM_SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlzcyI6InN1cGFiYXNlIiwiaWF0IjoxNzY2OTQxNjM2LCJleHAiOjIwODIzMDE2MzZ9.-krFMG4miJDqTdm2Kv70PfmFxyyChgCW-ldD75JCLHo';

export const supabase = createClient(CUSTOM_SUPABASE_URL, CUSTOM_SUPABASE_ANON_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});

